const evaluateRules = (world, rules) => {
    const sortedRules = rules.sort((a,b) => a.priority||0 - b.priority||0)
    const errors = []
    const emit = (rule) => (val, severity='error') => errors.push({path: rule.name, val, severity })

    for (const idx in sortedRules) {
        const rule = sortedRules[idx];
        const output = rule.run?rule.run(world, emit(rule)):null
    }
    return errors
}

export default evaluateRules